import { useParams, useRouteMatch } from 'react-router-dom'

import {
  Model,
  LoadingContainer,
  Modal,
  Panels,
  Bar,
  Input,
  LegacyPage,
  Breadcrumb,
} from 'peach/components'
import { getName } from 'peach/helpers'
import { CrossCompanyRolesSelect } from 'peach/scopes/session'

import { useInternalUserGet, useInternalUserUpdate } from 'core/types'

const CompanyUser = () => {
  const { url } = useRouteMatch()
  const { companyId, userId } = useParams<{
    companyId?: string
    userId?: string
  }>()

  const {
    data: user,
    isLoading,
    error,
  } = useInternalUserGet({ companyId, userId })

  const { mutateAsync: updateUser } = useInternalUserUpdate({
    companyId,
    userId,
  })

  const editUser = (
    <Modal
      initialValue={{ roles: user?.roleIds || [], ...user }}
      onSubmit={async (values) => {
        const { roles, borrowerId } = values
        await updateUser({ roles, borrowerId: borrowerId ?? undefined })
      }}
      title='Edit User'
      trigger
    >
      <Input formKey='borrowerId' />

      <CrossCompanyRolesSelect companyId={companyId} formKey='roles' />
    </Modal>
  )

  const header = <Bar right={editUser} title={getName(user)} />

  return (
    <Panels header={header}>
      <Breadcrumb title={getName(user)} to={url} />
      <LoadingContainer error={error} isLoading={isLoading}>
        <LegacyPage.Full>
          <Model.Item json={user} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default CompanyUser
